// Internal modules
import { logger } from '@/lib/logger';

type FptiPayload = {
  optsel?: string;
  transition_name?: string;
  int_error_code?: string;
  int_error_desc?: string;
};
const getPayload = (
  payload: FptiPayload,
): FptiPayload & {
  state_name: 'crs_interstitial';
} => {
  return {
    state_name: 'crs_interstitial',
    ...payload,
  };
};

export const logCrsTaxStatusSelection = (taxStatus: string): void => {
  logger.fpti(
    'crs_tax_status',
    getPayload({
      optsel: taxStatus,
      transition_name: 'process_tax_status_selection',
    }),
  );
};

type CRSPayload = {
  transition_name: string;
  optsel?: string;
};
type CRSEvent = {
  target: {
    id: string;
    value: string;
  };
  type: string;
};

export const logCrsFieldEvents = (event: CRSEvent): void => {
  if (!event) {
    return;
  }

  const {
    target: { id, value },
    type,
  } = event;

  const payload: CRSPayload = {
    transition_name: `process_${id}_${type}`,
  };

  if (type === 'change') {
    payload.optsel = value;
  }

  logger.fpti(`crs_${id}`, getPayload(payload));
};

type LogCrsErrorsParams = {
  error: string;
  field: string;
};
export const logCrsErrors = ({
  error = '',
  field,
}: LogCrsErrorsParams): void => {
  logger.fpti(
    `crs_${field}_error`,
    getPayload({
      int_error_code: '1',
      int_error_desc: error,
      transition_name: `process_${field}_validation`,
    }),
  );
};

export const logAddingCrsTaxDetails = (): void => {
  logger.fpti('crs_add_country_and_tax_details', {
    state_name: 'crs_interstitial',
    transition_name: 'process_add_country_click',
  });
};

export const logRemovingCrsTaxDetails = (): void => {
  logger.fpti('crs_remove_country_and_tax_details', {
    state_name: 'crs_interstitial',
    transition_name: 'process_remove_country_click',
  });
};
